import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { ArrowTriangleBlack } from '../../../asset/icon/ArrowTriangleBlack';
import { DeleteIcon } from '../../../asset/icon/DeleteIcon';
import { removeTempSectionInSides, setOpenSectionIdInSides } from '../../../store/actions/setting';
import { getOpenSectionIdInSides } from '../../../store/selectors/selectors';
import { inputComponentsAdditionalProperties } from '../LineParam/LineParams';
//@ts-ignore
import s from './SectionOpening.module.scss';

export type SectionOpeningT = {
    children?: any;
    key?: string;
    label?: string;
    isRemoveSection: boolean,
    [key: string]: unknown,
    parentKeySection: string,
    additionalProperties?: inputComponentsAdditionalProperties
}

export const SectionOpening = ({ ...props }: SectionOpeningT) => {
    const { label, key, children, isRemoveSection, id, parentKeySection, additionalProperties } = props;
    const dispatch = useDispatch();

    let sectionClass = `${s.selectSection}`
    let openSectionIdInSides: string = useSelector(getOpenSectionIdInSides);
    if (openSectionIdInSides === id) sectionClass += `  ${s.selectSection_Active}`;

    let style: any = {};

    const onSelect = (props: any) => {
        dispatch(setOpenSectionIdInSides({ idSection: id }))
    }

    let deleteSection = ({ keySection }: any) => {
        dispatch(removeTempSectionInSides({ keySection }))
    }

    if (additionalProperties && additionalProperties['groupGap']) {
        style = {
            ...style,
            display: 'grid',
            gap: '15px',
        }
    }
    if (additionalProperties && additionalProperties['gap']) {
        style = {
            ...style,
            gap: additionalProperties['gap'],
        }
    }
    if (additionalProperties && additionalProperties['backgroundColor']) {
        style = {
            ...style,
            backgroundColor: additionalProperties['backgroundColor'],
        }
    }
    if (additionalProperties && additionalProperties['padding']) {
        style = {
            ...style,
            padding: additionalProperties['padding'],
        }
    }
    if (additionalProperties && additionalProperties['margin']) {
        style = {
            ...style,
            margin: additionalProperties['margin'],
        }
    }
    // groupGap

    return (
        <div className={sectionClass} key={key} >
            <div className={s.header} onClick={() => onSelect(props)}>
                <div className={s.title}>{label}</div>
                <div className={s.icon}>  <ArrowTriangleBlack /></div>
            </div>
            <div className={s.main} >
                <div style={style} >
                    {children}
                    {isRemoveSection && (
                        <div className={s.footer_box}>
                            <div className={s.remove} onClick={() => deleteSection({ keySection: parentKeySection })}>
                                <DeleteIcon />
                                <div className={s.remove_label}>Remove</div>
                            </div>
                        </div>
                    )}
                </div>

            </div>


        </div>
    )
}
